import "../../Create/Create.css"
import {Selection} from "./component/Selection";
import {useState} from "react";
import {ChatSection} from "./component/ChatSection";
import {Context} from "./component/Context";
import {AiTextEditor} from "./component/AiTextEditor";
import {AboutTest} from "../component/AboutTest";
import {useLocation} from "react-router-dom";

export default function TestPrompt() {
    const {state} = useLocation()

    const [questions, setQuestions] = useState(null);
    const [chattingData, setChattingData] = useState([])
    const [startVal,setStartVal] = useState(false);

    return (
        <Context.Provider value={{setQuestions, questions, chattingData, setChattingData, startVal, state}}>
            <AboutTest  testId={state.testId}/>
            <Selection/>
            <div className={`${startVal ? "block" : "hidden"}`}>
                <ChatSection/>
                <AiTextEditor/>
            </div>
            <button
                onClick={() => {
                    setStartVal(true)
                }}
                className={`py-4 px-5 text-center bg-blue-800 text-white`}>시작하기
            </button>
        </Context.Provider>
    )
}